/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from "react";
import "./Styles/productdetail.css";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import trait from "../Images/Icones/trait.svg";
import TextField from '@mui/material/TextField';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios"
import Cookies from 'universal-cookie';
import moment from "moment/moment";
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function ProductDetail({ description, comments, productId, productSlug }) {
    const [value, setValue] = React.useState(0);
    const [load, setLoad] = React.useState(false)
    const [selectedStars, setSelectedStars] = React.useState(0);

    const [comment, setComment] = React.useState('');
    const [commentsDisplayed, setCommentsDisplayed] = React.useState([]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const cookies = new Cookies();

    const generateComment = (comment) => {
        let displayedStars = [];

        for (let index = 1; index <= comment.stars; index++) {
            displayedStars.push(<StarIcon sx={{ color: '#C8437E', fontSize: '20px' }} />)
        }

        for (let index = comment.stars+1; index <= 5; index++) {
            displayedStars.push(<StarOutlineIcon sx={{ color: '#C8437E', fontSize: '20px' }} />)
        }

        let date = moment(comment.createdAt).format("DD/MM/YYYY HH:mm:ss")

        return (
            <div className="comment-item">
                <h4>{comment.user.lastname} {comment.user.firstname}</h4>
                <h6>{date}</h6>
                <div className="stars">
                    {displayedStars}
                </div>
                <p>
                    {comment.content}
                </p>
            </div>
        )
    }

    useEffect(()=> {
        if (comments.length > 0) {
            comments.sort((a,b)=>(new Date(b.createdAt)).getTime() - (new Date(a.createdAt)).getTime());

            let arr = []
    
            comments.forEach(c => {

                arr.push(generateComment(c))
            })
    
            setCommentsDisplayed(arr)
        }
    }, [comments])

    const submitComment = () => {
        if (comment == '') {
            toast.error(
                "Vous devez saisir votre commentaire !"
            );
            return;
        }
        else if (selectedStars == 0) {
            toast.error(
                "Vous devez attribuer une note au produit !"
            );
            return;
        }

        setLoad(true)
        axios.post(process.env.REACT_APP_API_BASE_URL + '/api/comments',
            {
                content: comment,
                stars: selectedStars,
                product: 'api/products/' + productId,
                user: 'api/users/' + cookies.get('user').id
            }
            ,
            {
                headers: {
                    'x-api-token': process.env.REACT_APP_API_TOKEN
                }
            }).then(a => {

                axios.post(process.env.REACT_APP_API_BASE_URL + '/custom/update_product_stars?product='+productId, {
                    headers: {
                        'x-api-token': process.env.REACT_APP_API_TOKEN
                    }
                }).then(b => {
                    setLoad(false)
                    toast.success(
                        "Votre commentaire a bien été soumis !"
                    );

                    let arr = commentsDisplayed;

                    arr.unshift(generateComment(a.data))
                    setCommentsDisplayed(arr)

                    setComment('')
                    setSelectedStars(0)
                    chooseStars(0)
                })
            }).catch(error => {
                setLoad(false)
                toast.error(
                    "Une erreur est survenue ! Veuillez réessayer !"
                );
                console.log(error);
            })
    }

    const chooseStars = (number) => {
        setSelectedStars(number)
        let commentStars = document.querySelectorAll('.comment-star');

        for (let i = 0; i < commentStars.length; i++) {
            commentStars[i].classList.remove('comment-star-selected');
        }

        for (let i = 0; i < number; i++) {
            commentStars[i].classList.add('comment-star-selected');
        }
    }

    return (
        <>
            <ToastContainer />
            <Box sx={{ width: '97.5%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Description" {...a11yProps(0)} />
                        <Tab label="Avis" {...a11yProps(1)} />
                    </Tabs>
                </Box>

                <TabPanel value={value} index={1}>
                    <div className="comment-container">
                        {
                            cookies.get('user') ?
                                (<div className="comment-form">
                                    <h4>Laissez votre avis sur ce produit</h4>
                                    <p>
                                        <span onClick={() => { chooseStars(1) }}>
                                            <StarIcon className="comment-star" sx={{ fontSize: '40px' }} />
                                        </span>
                                        <span onClick={() => { chooseStars(2) }}>
                                            <StarIcon className="comment-star" sx={{ fontSize: '40px' }} />
                                        </span>
                                        <span onClick={() => { chooseStars(3) }}>
                                            <StarIcon className="comment-star" sx={{ fontSize: '40px' }} />
                                        </span>
                                        <span onClick={() => { chooseStars(4) }}>
                                            <StarIcon className="comment-star" sx={{ fontSize: '40px' }} />
                                        </span>
                                        <span onClick={() => { chooseStars(5) }}>
                                            <StarIcon className="comment-star" sx={{ fontSize: '40px' }} />
                                        </span>
                                    </p>
                                    <TextField
                                    disabled={load}
                                        sx={{ width: "100%" }}
                                        multiline
                                        placeholder='Donnez votre avis'
                                        minRows={5}
                                        value={comment}
                                        onChange={(e) => { setComment(e.target.value) }}
                                    />
                                    <button disabled={load} onClick={() => { submitComment() }}>Envoyer</button>
                                </div>) :
                                (
                                    <div className="comment-disabled">
                                        <h4>Vous devez être connecter avant de pouvoir laisser un avis</h4>
                                        <a href={"/connexion?redirectTo=/boutique/" + productSlug}>Se Connecter</a>
                                    </div>
                                )
                        }

                        <div className="comment-list">
                            {
                                commentsDisplayed.length > 0 ?
                                    commentsDisplayed :
                                    <div className="no-comments">
                                        <p>Aucun Commentaire Pour Le Moment</p>
                                    </div>
                            }
                        </div>
                    </div>
                </TabPanel>

                <TabPanel value={value} index={0}>
                    {description}
                </TabPanel>
            </Box>
        </>
    );
}


